<template lang="pug">
div
  .card
    .container-fluid
      .row
        .col-md-12
          .white-box
            h1.box-title.m-b-0 {{headname}} 
            p.text-muted.m-b-30.font-13 SWAN Proサイトの{{headname}}画面
              .form-group
                label(for='言語').col-md-12 言語
                .col-md-12
                  el-select(v-model='formdata.locale', @change='changeLocale')
                    el-option(value='ja', label='日本語')
                    el-option(value='en', label='英語')
                    el-option(value='cn', label='中国語') 
                    el-option(value='kr', label='韓国語')
              .form-group
                label.col-md-12 タイトル
                .col-md-12
                  input.form-control(type='text', v-model='formdata.page_title', name='title', value='', placeholder='HTMLのTITLE要素に記載されます')
              .form-group
                label.col-md-12 サブタイトル
                .col-md-12
                  input.form-control(type='text', v-model='formdata.page_subtitle', name='subtitle', value='', placeholder='HTMLのDESCRIPTIONに記載されます')
              .form-group(v-if='apiname === "contact"')
                label.col-md-12 問い合わせフォームリード
                .col-md-12
                  el-input(type='textarea', v-model='formdata.text1', autosize='', name='text1')
              .form-group(v-if='apiname === "contact"')
                label.col-md-12 問い合わせフォームサブリード
                .col-md-12
                  el-input(type='textarea', v-model='formdata.text1_2', autosize='', name='text1_2')
              .form-group(v-if='apiname === "contact"')
                label.col-md-12 問い合わせフォーム確認ボタン注意書き
                .col-md-12
                  el-input(type='textarea', v-model='formdata.text2', autosize='', name='text2')
              .form-group(v-if='apiname === "contact"')
                label.col-md-12 確認画面リード
                .col-md-12
                  el-input(type='textarea', v-model='formdata.text3', autosize='', name='text3')
              .form-group(v-if='apiname === "contact"')
                label.col-md-12 送信完了画面本文
                .col-md-12
                  el-input(type='textarea', v-model='formdata.text4', autosize='', name='text4')
              .form-group
                label.col-md-12 ヘッダ背景画像
                //- .col-md-12
                //-   input(type='file',　v-on:change='onFileAdd($event)')
              //- img(v-show='formdata.header_image' :src='formdata.header_image')
              .form-group(v-if='savedImageLength')
                //- label.col-md-12 登録済み画像
                .col-md-12
                  el-table(:data='header_image_arr')
                    el-table-column(label="image", width="300")
                      template(slot-scope="scope")
                        img(:src='scope.row.img_url', height='128')
                    el-table-column(property='img_url', label='image_url', width='500')
                    el-table-column(label='')
                      template(slot-scope='scope')
                        el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteConfirm(scope.$index)')
              .form-group(v-if='uploadedImagesLength')
                //- span.col-md-12 画像
                el-button(style='margin-left:18px', type='primary', icon='el-icon-plus', size='mini', @click='onBtnFileAdd', v-if='uploaded_images_arr.length === 0')
                .col-md-12
                  el-table(:data='uploaded_images_arr')
                    el-table-column(label='image', width='300')
                      template(slot-scope='scope')
                        img(:src='scope.row.image', height='128')
                    el-table-column(property='name', label='name', width='500')
                    el-table-column(label='')
                      template(slot-scope='scope')
                        el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteSubConfirm(scope.$index)') 
                input#btnFileAdd(type='file', style='visibility: hidden', @change='onFileAdd($event)', accept='image/*')
              .form-group
                label.col-md-12 リードテキスト
                .col-md-12
                  el-input(type='textarea', v-model='formdata.lead_text', :rows='2', name='keyword', placeholder='HTMLのKEYWORDに記載されます')
              .form-group
                label.col-md-12 プロモーションエリア
                .col-md-12
                  el-radio-group(v-model='formdata.promo_view')
                    el-radio(label="1", border) 表示
                    el-radio(label="2", border) 非表示
              .form-group
                label.col-md-12 地図エリア
                .col-md-12
                  el-radio-group(v-model='formdata.map_view')
                    el-radio(label="1", border) 表示
                    el-radio(label="2", border) 非表示
              el-button(@click='register', type='primary', size='medium') 登録
</template>

<script>
import axios from 'axios'

export default {
  name: 'subheader',
  data () {
    return {
      formdata: {
        'page_title': '',
        'page_subtitle': '',
        'header_image': '',
        'lead_text': '',
        'category': this.apiname,
        'category_name': '',
        'locale': 'ja',
        'promo_view': '',
        'map_view': ''
      },
      header_image_arr: [],
      uploaded_images_arr: []
    }
  },
  props: {
    apiname: String,
    headname: String
  },
  created () {
    this.getData()
  },
  methods: {
    register: function () {
      this.$confirm('変更しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        if (this.header_image_arr.length > 0) {
          this.formdata.header_image = this.header_image_arr[0].img_url
          this.formdata.uploadedImages = []
        } else {
          this.formdata.header_image = ''
          this.formdata.uploadedImages = this.uploaded_images_arr
        }
        axios({
          method: 'POST',
          baseURL: process.env.API_BASE_URL,
          url: '/admin/swan/base',
          data: this.formdata
        })
          .then((response) => {
            self.result = response
            console.log(self.result)
            this.$message({
              type: 'success',
              message: 'success '
            })
          })
          .catch((error) => {
            console.log(error)
            this.$message({
              type: 'info',
              message: 'error'
            })
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'canceled'
        })
      })
    },
    getData () {
      this.header_image_arr = []
      this.savedImageLength = false
      this.uploadedImagesLength = false
      axios({
        method: 'GET',
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/base?locale=' + this.formdata.locale + '&category=' + this.apiname
      })
        .then((response) => {
          let data = response.data
          if (data.header_image !== '') {
            this.savedImageLength = true
            this.header_image_arr.push({img_url: data.header_image})
            console.log(this.header_image_arr)
          } else {
            this.uploadedImagesLength = true
          }
          if (this.apiname === 'contact') {
            this.formdata.text1 = data.text1
            this.formdata.text1_2 = data.text1_2
            this.formdata.text2 = data.text2
            this.formdata.text3 = data.text3
            this.formdata.text4 = data.text4
          }
          this.formdata.page_title = data.page_title
          this.formdata.page_subtitle = data.page_subtitle
          this.formdata.header_image = data.header_image
          this.formdata.lead_text = data.lead_text
          this.formdata.category_name = data.category_name
          this.formdata.promo_view = data.promo_view
          this.formdata.map_view = data.map_view
        })
        .catch((error) => {
          console.log(error)
        })
    },
    changeLocale (e) {
      this.getData()
    },
    onBtnFileAdd (e) {
      document.getElementById('btnFileAdd').click()
    },
    onFileAdd (e) {
      let files = e.target.files || e.dataTransfer.files
      // console.log(files)
      if (files[0].type.match(/image/i)) {
        let reader = new FileReader()
        reader.onload = (r) => {
          this.uploaded_images_arr.push({ name: files[0].name, tag: '__REP_SUBIMG_' + this.subImageCount + '__', image: r.target.result, caption: '' })
        }
        // console.log(this.formdata)
        this.subImageCount++
        reader.readAsDataURL(files[0])
      } else {
        let msg = '画像ではありません'
        alert(msg)
      }
    },
    deleteConfirm (index) {
      this.$confirm('削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.header_image_arr.splice(index, 1)
        this.savedImageLength = false
        this.uploadedImagesLength = true
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    deleteSubConfirm (index) {
      console.log(index)
      this.$confirm(this.uploaded_images_arr[index].name + 'を削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.uploaded_images_arr.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/components/swan/common/SubHeader.vue